'use strict';
require(
['jquery'],
function($) {

  $(document).ready(function() {

    // Copy header.links into mobile nav
    $(document).ready(function() {
      var $storelinks = $('#store\\.links');
      var $accountlinks = $('.header.content > .header.links').clone();
      $accountlinks.appendTo($storelinks).addClass('mobile');
    });

    // Review scroll override.
    $('.catalog-product-view').each(function() {
      $('.reviews-actions > .action').click(function() {
        document.querySelector('#product-review-container').scrollIntoView({
          behavior: 'smooth'
        });
        return false;
      });

      // Disable description tab title toggle
      $('#tab-label-description-title').click(function(event) {
        event.preventDefault();
      });
    });

    // Mobile menu changes
    $('.menu-container .menu.vertical-left').each(function() {
      var $this = $(this);
      var $dropdown = $this.find('.dropdown');
      var $nestedMenu = $dropdown.find('.megaNormalMenu > ul');
      $nestedMenu.slideUp();
      $dropdown.find('.megaNormalMenu > h2').click(function() {
        $(this).parent().toggleClass('active');
        $(this).parent().siblings().removeClass('active');
        $(this).parent().siblings().children('ul').slideUp();
        $(this).siblings('ul').slideToggle();
      });
    });
  });

  // Fixed Navigation
  $(document).ready(function() {
    var initialScroll = 0;
    var header = $('header.page-header');
    $(header).css('transition', 'all 800ms ease 0s').css('top', 0);

    function hideNav() {
      $(header).removeClass('nav-peek');
    }

    function showNav() {
      $(header).addClass('nav-fixed').addClass('nav-peek');
    }

    $(window).scroll(function() {
      var currentScroll = $(this).scrollTop();
      if (currentScroll < 100) {
        showNav();
        $(header).css('top', 0);
        $(header).removeClass('nav-peek').removeClass('nav-fixed');
      }
      else if (currentScroll > 0 && currentScroll < $(document).height() - $(window).height()) {
        $(header).css('top', $(header).height() * -1);

        if (currentScroll > initialScroll) {
          hideNav();
        }
        else {
          showNav();
        }
        initialScroll = currentScroll;
      }
    });
  });

});
